import { request } from "../../../apis";
import { getCurrency } from "../../../plugins/utils";
const CURRENCY = getCurrency();

export const getAgentBonusHeader = ({ params }) =>
  request("get", `/${CURRENCY}/agent/bonus/header/`, { ...params }, true, false);

export const getAgentWinLoss = ({ params, agent_bonus_id, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/bonus/detail/winloss/${agent_bonus_id}`,
    { ...params, page },
    true,
    false,
  );

export const getPlatformFee = ({ params, agent_bonus_id, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/bonus/detail/gamefee/${agent_bonus_id}`,
    { ...params, page },
    true,
    false,
  );

export const getPromotionFee = ({ params, agent_bonus_id, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/bonus/detail/promotefee/${agent_bonus_id}`,
    { ...params, page },
    true,
    false,
  );

export const getLevelBonus = ({ params, agent_bonus_id, level, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/bonus/detail/levelbonus/${agent_bonus_id}/${level}`,
    { ...params, page },
    true,
    false,
  );

export const getComissionOverview = () =>
  request("get", `/${CURRENCY}/agent/dashboard/bonus`, {}, true, false);

export const getAgentRebateLevel = () =>
  request("get", `/${CURRENCY}/agent/rebate/level`, {}, true, false);

export const getDepositRebateRate = () =>
  request("get", `/${CURRENCY}/agent/deposit/bonus`, {}, true, false);

export const getNetLossLevelProgress = () =>
  request("get", `/${CURRENCY}/agent/netloss/level/progress`, {}, true, false);
